// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"07f36424","175":"80d8007e","531":"e98d7638","585":"08b98185","626":"b22cf6ac","656":"08f7e707","927":"c5f5cc7c"}[chunkId] + ".chunk.js";
};